import styles from '../ProductActivityPage.module.css'
import { chipLabel } from '../../lib/tagLabel'

// A Tagless harvest handover has no bucket code (the picker's tag names a
// person), so its cycle is keyed on the phone's record id. Screens call it
// "Tagless" plus the id's last characters, its random part, enough to tell one
// bucket from the next; the full id still searches and exports
// (api services/item-label.js says the same). A bin tag is named by the ID
// printed on it (VMT2, not DT32233002); its raw code still searches and exports.
// A picker's share of a shared bin is keyed on its record id too, but is named
// by its bin (big_bin, the ID printed on the bin's tag): "B1 (Bin shared)".

export const TAGLESS_TAIL = 4

interface Named {
  item_code: string | null
  tagless?: boolean
  big_bin?: string | null
}

export const taglessTail = (code: string) => code.slice(-TAGLESS_TAIL)

export const sharedBinName = (bin: string) => `${bin} (Bin shared)`

export const itemName = (c: Named): string =>
  c.big_bin ? sharedBinName(c.big_bin) : c.tagless && c.item_code ? `Tagless · ${taglessTail(c.item_code)}` : chipLabel(c.item_code)

// What a spreadsheet gets: the whole id, said to be tagless.
export const itemExport = (c: Named): string =>
  c.big_bin ? `${sharedBinName(c.big_bin)} ${c.item_code || ''}`.trim() : c.tagless && c.item_code ? `Tagless ${c.item_code}` : c.item_code || ''

export function ItemName({ c }: { c: Named }) {
  if (!c.item_code) return null
  if (c.big_bin) return <span title={`Shared bin ${c.big_bin} · phone record ${c.item_code}`}>{sharedBinName(c.big_bin)}</span>
  if (!c.tagless) {
    const label = chipLabel(c.item_code)
    return label === c.item_code ? <>{label}</> : <span title={c.item_code}>{label}</span>
  }
  return (
    <span title={`Tagless · phone record ${c.item_code}`}>
      Tagless <span className={styles.itemTail}>· {taglessTail(c.item_code)}</span>
    </span>
  )
}
